<template>
  <div ref="wrapper" class="ui-edit__right" :class="{ 'overflow-hidden': SiteMenu.selected.length }">
    <!--编辑菜单-->
    <transition-group name="slide-fade" tag="div">
      <template v-for="(item, index) in SiteMenu.selected">
        <component
          :is="'edit-' + item.key"
          v-if="item.target && selectWidget"
          :id="'edit-menu-wrap-' + index"
          :key="index + item.key + item.target.id"
          :device="device"
          tag="div"
          class="edit-menu-wrap"
          :model="item.model? item.model : item.target"
          :target="item.target"
          :site="currentSite"
          v-bind="item.config || {}">
        </component>
      </template>
    </transition-group>
    <!-- 标题区域：始终可见，不参与滚动 -->
    <menu-title class="ui-edit__right__title" :f-size="14">
      <span>{{ $t(`model.${currentMenuInfo.title}`) }}</span>
      <span v-if="currentMenuInfo?.tag">-{{ currentMenuInfo.tag }}</span>
    </menu-title>
    <!-- 表单滚动区 -->
    <div ref="scroll" class="ui-edit__right__scroll">
      <component :is="selectWidget.name.replace('Model','Edit')" v-if="selectWidget" :key="selectWidget.id" :site="currentSite" :device="device" :model="selectWidget" :site-lang-model="siteLangModel" :editing="true" @clone="onClone" />
    </div>
    <!-- 删除 区块弹窗-->
    <DeleteBlockDialog
      v-model="SiteMenu.deleteBlockVisible"
      @close="SiteMenu.deleteBlockVisible = false"
      @delete-block="deleteBlock"
    >
    </DeleteBlockDialog>
  </div>
</template>

<script>
import DeleteBlockDialog from '~/site/components/editMenu/deleteBlockDialog';
import {editComponents} from '~/site/model/components'
import deleteSvg from '~/assets/svg/icon/delete.svg'
import EditCarousel from '~/site/components/editMenu/carousel.vue'
import EditCollapseRow from '~/site/components/editMenu/collapse.vue'
import EditBackground from '~/site/components/editMenu/background.vue'
import EditGlobalBackground from '~/site/components/editMenu/globalBackground.vue'
import EditFooterText from '~/site/widgets/footerWidget/textEdit.vue'
import EditFooterImage from '~/site/widgets/footerWidget/imageEdit.vue'
import EditFooterMedia from '~/site/widgets/footerWidget/mediaEdit.vue'
import EditFooterQuickLink from '~/site/widgets/footerWidget/quickLinkEdit.vue'
import EditImageTextItem from '~/site/widgets/imageTextWidget/itemEdit.vue'
import EditLogin from '~/site/components/editMenu/login.vue'
import EditBindUser from '~/site/components/editMenu/bindUser.vue'
import EditSingGoodsItem from '~/site/widgets/singleGoodsWidget/goodsItemEdit.vue'
import EditDialogItem from '~/site/widgets/dialogCollectionWidget/dialogItemEdit.vue'
import EditNavediter from '~/site/components/editMenu/navEditer.vue'
import MenuTitle from "~/components/menu/menuTitle"
import WarningSvg from '~/assets/svg/icon/warning.svg'

export default {
  name: "UiEditRight",
  components: {
    ...editComponents,
    EditBackground,
    EditFooterMedia,
    EditCollapseRow,
    EditCarousel,
    EditGlobalBackground,
    EditNavediter,
    EditFooterText,
    EditFooterImage,
    EditFooterQuickLink,
    EditLogin,
    EditBindUser,
    DeleteBlockDialog,
    deleteSvg,
    WarningSvg,
    MenuTitle,
    EditImageTextItem,
    EditSingGoodsItem,
    EditDialogItem
  },
  props: {
    currentSite: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    siteLangModel: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    selectWidget: {
      type: Object,
      required: true,
      default() {
        return {
          colorKey: 'backgroundColor',
          imageKey: 'backgroundImage',
        }
      }
    },
    device: {
      type: String,
      default: 'desktop'
    }
  },
  data() {
    return {
      visible: false,
      extend: {},
      target: '',
      suggestion: null, // 背景图的宽高
      subMenus: {
        menu: '',
        target: null,
        config: {}
      },
      threeMenus:{
        menu: '',
        target: null
      },
      menuConfig: ''
    }
  },
  computed: {
    currentMenuInfo() {
      return this.selectWidget?.getMenuInfo()
    }
  },
  mounted() {
    this.listenSiteMenuOpen()
  },
  created() {},
  methods: {
    listenSiteMenuOpen() {
      this.SiteMenu.$bus.$on('open', () => {
        const $scroll = this.$refs.scroll
        if ($scroll) {
          $scroll.scrollTop = 0
        }
      })
    },
    onParentMenuClose() {
      this.$emit('clear-select')
    },
    deleteBlock() {
      this.$emit('delete-widget')
      this.SiteMenu.closeDeleteBlockDialog()
    },
    onClone(model) {
      this.$emit('clone', model)
    },
    handleShowDeleteDialog() {
      this.SiteMenu.openDeleteBlockDialog()
    }
  }
}
</script>

<style lang="less">
.ui-edit__right {
  padding: 0;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  background: rgba(18, 18, 23, 0.95);
  backdrop-filter: blur(20px);
  // border-left: 1px solid rgba(255, 255, 255, 0.06);

  // 标题区域：固定不滚动，精致 header
  .ui-edit__right__title {
    flex-shrink: 0;
    position: relative;
    padding: 14px 16px 13px !important;
    margin-bottom: 0 !important;
    border-bottom: none !important;
    // 轻微抬升的渐变背景，与滚动区形成层次
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.045) 0%, rgba(255, 255, 255, 0.015) 100%);

    // 底部渐变分隔线（中间亮、两端淡），替代生硬实线
    &::after {
      content: '';
      position: absolute;
      left: 16px;
      right: 16px;
      bottom: 0;
      height: 1px;
      background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.16) 30%, rgba(255, 255, 255, 0.16) 70%, transparent 100%);
    }

    .line {
      height: 14px !important;
      width: 3px !important;
      box-shadow: 0 0 10px rgba(var(--primary-color-rgb), 0.65);
    }
  }

  // 表单滚动区
  .ui-edit__right__scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 14px 16px 80px;
    // 去掉滚动条宽度占位（隐藏滚动条，保留滚动）
    scrollbar-width: none; // Firefox
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
  }

  .edit-menu-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 20px;
    z-index: 2000;
    background: rgba(18, 18, 23, 0.95);
    backdrop-filter: blur(20px);
    overflow-y: auto;
    
    // 隐藏滚动条
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.1);
      border-radius: 4px;
    }
  }

  .menu-item {
    &:first-child {
      padding-top: 0;
    }
  }

  .edit-content-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 48px;
    overflow-y: auto;
    padding-bottom: 24px;
  }

  .edit-title {
    color: rgba(255, 255, 255, 0.9);
    position: relative;
    height: 24px;
    line-height: 24px;
    font-size: 16px;
    font-weight: 600;
    padding-left: 16px;
    padding-bottom: 40px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    letter-spacing: 0.5px;

    &:before {
      content: ' ';
      position: absolute;
      left: 0;
      width: 4px;
      height: 16px;
      top: 4px;
      background: var(--primary-color);
      border-radius: 2px;
      box-shadow: 0 0 8px rgba(var(--primary-color-rgb), 0.6);
    }
  }
}
</style>
